// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H_2asCYDgjX0yQyvcrrn {
  display: flex;
  height: auto;
  width: 100%;
  flex-direction: column;
  gap: 1.25rem;
  font-family: Noto Sans;
}

.h5NdxtRf8VesrE6MmkMx {
  margin-top: 0.5rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

.ah51s5u1EyFDzpNv3pQz {
  margin-bottom: 0.5rem;
  font-family: Noto Sans;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
}

.AiwwJ5ySvOiCRBHSrMPL {
  margin-bottom: 0.5rem;
  font-family: Noto Sans;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
}

.q7PbkVtGahoG9vQPy2q7 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Xc4Xg7JQ2ACIV77EGvbh {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.mJcSu6uJLwkGSO4OEo9D {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(242 250 254 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}

.Ofr1dsuaun5zLzHVw_77 {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.VM38hh7JwfBCUCSwR1ON {
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-weight: 700;
}

.umG_p2b5aHFXlJCJQqds {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.ylTbdB8fYhrTAMggf2iW {
  font-family: Noto Sans;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
}

.eITQbNlsEYojlDdaXcVs {
  /* @apply ; */
}

.sFC_xk4cb_IvN_vZJWj8 {
  margin-bottom: 0.75rem;
  height: auto;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}
.wVNNPcbcv16djplMAD9z {
  margin-bottom: 0.75rem;
  height: auto;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
  padding: 1rem;
}
.DeErpIrBngOAs_Iw2ve8 {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  height: auto;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
  padding: 0.75rem;
}
.cICky6NqvH9e9sEZmV64 {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-family: Noto Sans;
  font-size: 0.75rem;
  line-height: 1rem;
}
.pSsbe4V9SfayBg3T85uL {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.VdKlxH4pur3IdAqmSeuJ {
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 600;
}
.bLRNu7R1VmRHx4HQ3Ewm {
  cursor: pointer;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1));
  text-decoration-line: underline;
}
.E2CjZ67jRs4WWfx7iH4x {
  margin-top: 0.5rem;
  display: flex;
  height: auto;
  width: 100%;
  align-items: center;
}
.vpV9dOdjsbsgjOjI10oy {
  margin-top: 0.5rem;
  font-size: 12px;
}

.wmJNs2xJ2Swxgkk7Sgef {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.fIFStyuncJANlXJfNIYQ {
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  border-radius: 0.375rem;
  --tw-border-opacity: 1 !important;
  border-color: rgb(219 39 119 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0.5rem;
  font-family: Noto Sans;
  font-weight: 600;
}

.fIFStyuncJANlXJfNIYQ:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(219 39 119 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  font-weight: 600;
}

.fIFStyuncJANlXJfNIYQ.ant-btn-variant-outlined {
  border-color: 1.5PX !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(219 39 119 / var(--tw-border-opacity, 1)) !important;
}

.fIFStyuncJANlXJfNIYQ.ant-btn-variant-outlined:hover {
  border-color: 1.5PX !important;
  --tw-border-opacity: 1 !important;
  border-color: rgb(219 39 119 / var(--tw-border-opacity, 1)) !important;
}

.WddngL0Ti9M86RiESetd {
  height: 35px;
  width: 35px;
}
.jt7cWfKtMBKmR2GYiX8W {
  margin-top: 1.5rem;
  display: flex;
  height: auto;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
}

.VwzfJqxgv6aWUiSicBBe {
  height: 132px;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1rem;
  font-family: Noto Sans;
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.TNkJCmfwQkOpCEBPfpqj {
  font-family: Noto Sans;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
}

.Qd9cpwLOzjAKFQi_ZNZJ {
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}

.rDOqS1vitfScA_uoZ7eH {
  margin-top: 1.25rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-family: Noto Sans;
}

.krU4IBMsiFmo0J0sGQfA {
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
}

.Aoxzc42evR50MffDERBZ {
  width: 70px;
  cursor: pointer;
  border-radius: 1.5rem;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  padding: 6px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.UPWdfwqw4eIULNM53clr {
  width: 70px;
  cursor: pointer;
  border-radius: 1.5rem;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
  padding: 6px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.YxjTtWcsRUtblfoq8Q82 .ant-tag-close-icon {
  --tw-text-opacity: 1 !important;
  color: rgb(244 49 49 / var(--tw-text-opacity, 1)) !important;
}

.YxjTtWcsRUtblfoq8Q82 .ant-tag-close-icon:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(244 49 49 / var(--tw-text-opacity, 1)) !important;
}

.lHFO0QU2yHxoiN7fP7II {
  margin: auto;
  margin-top: 0.75rem;
  display: flex;
  height: 47px;
  width: 98%;
  align-items: center;
  gap: 1rem;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 203 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.CQZZSZU1XtmvDF9IcmHS {
  height: 34px;
  width: 34px;
  border-radius: 5px;
  -o-object-fit: contain;
     object-fit: contain;
}
.XtsxM3m1GbpIQbcjlLk2 {
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(164 133 10 / var(--tw-text-opacity, 1));
}

.Qx4QdK1DMcyrt0jeAlzy {
  display: flex;
  width: 60%;
}

.Qx4QdK1DMcyrt0jeAlzy .ant-radio-button-wrapper:has(:focus-visible) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.Qx4QdK1DMcyrt0jeAlzy .ant-radio-button-wrapper > .ant-radio-button {
  position: static;
  z-index: auto;
}

/* Default tab border color */
.Qx4QdK1DMcyrt0jeAlzy .ant-radio-button-wrapper {
  border-color: #d9d9d9;
}

.Qx4QdK1DMcyrt0jeAlzy .ant-radio-button-wrapper-checked {
  --tw-border-opacity: 1;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.Qx4QdK1DMcyrt0jeAlzy .ant-radio-button-wrapper-checked:hover {
  --tw-border-opacity: 1;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.Qx4QdK1DMcyrt0jeAlzy
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
  border-color: transparent;
}
.Qx4QdK1DMcyrt0jeAlzy .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: transparent !important;
}

.Qx4QdK1DMcyrt0jeAlzy
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/PriceSummaryModal/PriceSummaryModal.module.css"],"names":[],"mappings":"AACE;EAAA,aAAmD;EAAnD,YAAmD;EAAnD,WAAmD;EAAnD,sBAAmD;EAAnD,YAAmD;EAAnD;AAAmD;;AAInD;EAAA,kBAAmE;EAAnE,aAAmE;EAAnE,WAAmE;EAAnE,sBAAmE;EAAnE,uBAAmE;EAAnE,kBAAmE;EAAnE,4DAAmE;EAAnE;AAAmE;;AAInE;EAAA,qBAA8C;EAA9C,sBAA8C;EAA9C,eAA8C;EAA9C,mBAA8C;EAA9C;AAA8C;;AAI9C;EAAA,qBAA8C;EAA9C,sBAA8C;EAA9C,eAA8C;EAA9C,mBAA8C;EAA9C;AAA8C;;AAI9C;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;;AAI1B;EAAA,aAAkC;EAAlC,WAAkC;EAAlC;AAAkC;;AAIlC;EAAA,aAAiE;EAAjE,WAAiE;EAAjE,sBAAiE;EAAjE,WAAiE;EAAjE,uBAAiE;EAAjE,kBAAiE;EAAjE,4DAAiE;EAAjE;AAAiE;;AAIjE;EAAA,aAAkC;EAAlC,WAAkC;EAAlC;AAAkC;;AAIlC;EAAA,aAA4C;EAA5C,WAA4C;EAA5C,8BAA4C;EAA5C;AAA4C;;AAI5C;EAAA,aAAkC;EAAlC,WAAkC;EAAlC;AAAkC;;AAIlC;EAAA,sBAAyC;EAAzC,eAAyC;EAAzC,mBAAyC;EAAzC;AAAyC;;AAG3C;EACE,aAAa;AACf;;AAGE;EAGA,sBAAiD;EAAjD,YAAiD;EAAjD,WAAiD;EAAjD,qBAAiD;EAAjD,kBAAiD;EAAjD,4DAAiD;EAAjD;AAHiD;AAMjD;EAAA,sBAA4D;EAA5D,YAA4D;EAA5D,WAA4D;EAA5D,qBAA4D;EAA5D,kBAA4D;EAA5D,4DAA4D;EAA5D;AAA4D;AAG5D;EAAA,kBAAiE;EAAjE,sBAAiE;EAAjE,YAAiE;EAAjE,WAAiE;EAAjE,qBAAiE;EAAjE,kBAAiE;EAAjE,4DAAiE;EAAjE;AAAiE;AAGjE;EAAA,aAA0D;EAA1D,WAA0D;EAA1D,8BAA0D;EAA1D,oBAA0D;EAA1D,uBAA0D;EAA1D,sBAA0D;EAA1D,kBAA0D;EAA1D;AAA0D;AAG1D;EAAA,aAAkC;EAAlC,WAAkC;EAAlC;AAAkC;AAGlC;EAAA,sBAA2C;EAA3C,eAA2C;EAA3C;AAA2C;AAG3C;EAAA,eAA6E;EAA7E,sBAA6E;EAA7E,eAA6E;EAA7E,gBAA6E;EAA7E,oBAA6E;EAA7E,iDAA6E;EAA7E;AAA6E;AAG7E;EAAA,kBAA2C;EAA3C,aAA2C;EAA3C,YAA2C;EAA3C,WAA2C;EAA3C;AAA2C;AAG3C;EAAA,kBAAuB;EAAvB;AAAuB;;AAIvB;EAAA,aAAoD;EAApD,WAAoD;EAApD,mBAAoD;EAApD,uBAAoD;EAApD;AAAoD;;AAIpD;EAAA,aAAuG;EAAvG,wBAAuG;EAAvG,mBAAuG;EAAvG,uBAAuG;EAAvG,kBAAuG;EAAvG,mBAAuG;EAAvG,uBAAuG;EAAvG,iCAAuG;EAAvG,sEAAuG;EAAvG,kBAAuG;EAAvG,4DAAuG;EAAvG,eAAuG;EAAvG,sBAAuG;EAAvG;AAAuG;;AAIvG;EAAA,iCAA+C;EAA/C,sEAA+C;EAA/C,6BAA+C;EAA/C,uEAA+C;EAA/C;AAA+C;;AAI/C;EAAA,8BAAuC;EAAvC,iCAAuC;EAAvC;AAAuC;;AAIvC;EAAA,8BAAuC;EAAvC,iCAAuC;EAAvC;AAAuC;;AAIvC;EAAA,YAAwB;EAAxB;AAAwB;AAGxB;EAAA,kBAA6C;EAA7C,aAA6C;EAA7C,YAA6C;EAA7C,WAA6C;EAA7C,sBAA6C;EAA7C;AAA6C;;AAI7C;EAAA,aAAqE;EAArE,WAAqE;EAArE,qBAAqE;EAArE,kBAAqE;EAArE,4DAAqE;EAArE,aAAqE;EAArE,sBAAqE;EAArE,gDAAqE;EAArE,6DAAqE;EAArE;AAAqE;;AAIrE;EAAA,sBAAuC;EAAvC,mBAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;;AAIvC;EAAA,sBAAmD;EAAnD,mBAAmD;EAAnD,oBAAmD;EAAnD,gBAAmD;EAAnD,oBAAmD;EAAnD;AAAmD;;AAInD;EAAA,mBAAkD;EAAlD,aAAkD;EAAlD,WAAkD;EAAlD,8BAAkD;EAAlD;AAAkD;;AAIlD;EAAA,sBAAqC;EAArC,mBAAqC;EAArC,oBAAqC;EAArC;AAAqC;;AAIrC;EAAA,WAAkG;EAAlG,eAAkG;EAAlG,qBAAkG;EAAlG,kBAAkG;EAAlG,kBAAkG;EAAlG,0DAAkG;EAAlG,YAAkG;EAAlG,kBAAkG;EAAlG,oBAAkG;EAAlG;AAAkG;;AAIlG;EAAA,WAAgG;EAAhG,eAAgG;EAAhG,qBAAgG;EAAhG,kBAAgG;EAAhG,kBAAgG;EAAhG,0DAAgG;EAAhG,YAAgG;EAAhG,kBAAgG;EAAhG,oBAAgG;EAAhG;AAAgG;AAGhG;EAAA,+BAAuB;EAAvB;AAAuB;;AAIvB;EAAA,+BAAuB;EAAvB;AAAuB;;AAIvB;EAAA,YAAoG;EAApG,mBAAoG;EAApG,aAAoG;EAApG,YAAoG;EAApG,UAAoG;EAApG,mBAAoG;EAApG,SAAoG;EAApG,kBAAoG;EAApG,kBAAoG;EAApG,4DAAoG;EAApG,oBAAoG;EAApG,qBAAoG;EAApG,iBAAoG;EAApG;AAAoG;AAGpG;EAAA,YAAqD;EAArD,WAAqD;EAArD,kBAAqD;EAArD,sBAAqD;KAArD;AAAqD;AAGrD;EAAA,sBAA4E;EAA5E,eAA4E;EAA5E,gBAA4E;EAA5E,oBAA4E;EAA5E;AAA4E;;AAI5E;EAAA,aAAmB;EAAnB;AAAmB;;AAInB;EAAA,8BAAmB;EAAnB;AAAmB;AAErB;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;AACvB;;AAGE;EAAA,sBAA2C;EAA3C,0DAA2C;EAA3C,kBAA2C;EAA3C,0DAA2C;EAA3C,oBAA2C;EAA3C;AAA2C;;AAI3C;EAAA,sBAA2C;EAA3C,0DAA2C;EAA3C,kBAA2C;EAA3C,0DAA2C;EAA3C,oBAA2C;EAA3C;AAA2C;;AAG7C;;EAEE,yBAAyB;AAC3B;AACA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C","sourcesContent":[".mainContainer {\n  @apply w-full h-auto flex flex-col gap-5 font-inter;\n}\n\n.feesAndCharges {\n  @apply w-full bg-layoutBackground rounded-md p-4 flex flex-col mt-2;\n}\n\n.feesAndChargesHeader {\n  @apply text-base font-semibold font-inter mb-2;\n}\n\n.paymentBrakeDownHeader {\n  @apply text-base font-semibold font-inter mb-2;\n}\n\n.feesAndChargesBrakeDown {\n  @apply flex flex-col gap-2;\n}\n\n.feesAndChargesBrakeDownItem {\n  @apply w-full flex justify-between;\n}\n\n.paymentBrakeDown {\n  @apply w-full rounded-md p-4 flex flex-col gap-2 bg-tableExpandBG;\n}\n\n.paymentBrakeDownItem {\n  @apply w-full flex justify-between;\n}\n\n.paymentBrakeDownItemNetPayable {\n  @apply w-full flex justify-between font-bold;\n}\n\n.paymentDetailsWrapper {\n  @apply w-full flex justify-between;\n}\n\n.paymentDetailsHeader {\n  @apply text-base font-semibold font-inter;\n}\n\n.paymentDetailsTicketCount {\n  /* @apply ; */\n}\n\n.promotionSection {\n  @apply w-full h-auto rounded-lg bg-white p-4 mb-3;\n}\n.promotionSection {\n  @apply w-full h-auto rounded-lg bg-white p-4 mb-3;\n}\n.voucherSection {\n  @apply w-full h-auto rounded-lg bg-layoutBackground p-4 mb-3;\n}\n.pledgeDetailsSection {\n  @apply w-full h-auto rounded-lg bg-layoutBackground p-3 mb-3 my-2;\n}\n.pledgeDetailsItem {\n  @apply w-full flex justify-between text-xs font-inter py-1;\n}\n.promotionSectionHeader {\n  @apply w-full flex justify-between;\n}\n.promotionSectionTitle {\n  @apply text-[14px] font-semibold font-inter;\n}\n.promotionButton {\n  @apply text-primary font-bold text-[12px] cursor-pointer underline font-inter;\n}\n.promotionSectionBody {\n  @apply w-full h-auto flex items-center mt-2;\n}\n.noPromotionApplied {\n  @apply text-[12px] mt-2;\n}\n\n.buttonWrapper {\n  @apply w-full flex gap-4 items-center justify-center;\n}\n\n.proceedToPayButton {\n  @apply bg-white font-inter font-semibold !border-pink-600  w-fit h-fit flex items-center p-2 rounded-md;\n}\n\n.proceedToPayButton:hover {\n  @apply !bg-white font-semibold !border-pink-600;\n}\n\n.proceedToPayButton:global(.ant-btn-variant-outlined) {\n  @apply !border-[1.5PX] !border-pink-600;\n}\n\n.proceedToPayButton:global(.ant-btn-variant-outlined:hover) {\n  @apply !border-[1.5PX] !border-pink-600;\n}\n\n.imageLogo {\n  @apply h-[35px] w-[35px];\n}\n.promotionListWrapper {\n  @apply w-full h-auto mt-6 flex flex-col gap-4;\n}\n\n.promotionListItem {\n  @apply w-full h-[132px] bg-white rounded-lg p-4 shadow-2xl font-inter;\n}\n\n.promotionCode {\n  @apply text-lg font-semibold font-inter;\n}\n\n.promotionRemarks {\n  @apply text-sm font-normal text-gray-300 font-inter;\n}\n\n.promotionBottomRow {\n  @apply w-full mt-5 flex justify-between font-inter;\n}\n\n.promotionValidity {\n  @apply text-sm font-medium font-inter;\n}\n\n.promotionApplyButton {\n  @apply w-[70px] bg-secondary border-none rounded-3xl text-white text-center p-[6px] cursor-pointer;\n}\n\n.promotionRemoveButton {\n  @apply w-[70px] bg-red-600 border-none rounded-3xl text-white text-center p-[6px] cursor-pointer;\n}\n.customTag :global(.ant-tag-close-icon) {\n  @apply !text-danger-100;\n}\n\n.customTag :global(.ant-tag-close-icon:hover) {\n  @apply !text-danger-100;\n}\n\n.wrapperDetails {\n  @apply bg-warningCardBG h-[47px] w-[98%] m-auto mt-3 px-2 rounded-[5px] items-center flex gap-4 py-4;\n}\n.icon {\n  @apply w-[34px] h-[34px] object-contain rounded-[5px];\n}\n.sectionTitle {\n  @apply text-warningTextColor font-dashboardMain text-dashboardSub font-inter;\n}\n\n.customTab {\n  @apply w-[60%] flex;\n}\n\n.customTab :global(.ant-radio-button-wrapper:has(:focus-visible)) {\n  @apply outline-none;\n}\n.customTab :global(.ant-radio-button-wrapper > .ant-radio-button) {\n  position: static;\n  z-index: auto;\n}\n\n/* Default tab border color */\n.customTab :global(.ant-radio-button-wrapper) {\n  border-color: #d9d9d9;\n}\n\n.customTab :global(.ant-radio-button-wrapper-checked) {\n  @apply border-primary bg-primary text-white;\n}\n\n.customTab :global(.ant-radio-button-wrapper-checked:hover) {\n  @apply border-primary bg-primary text-white;\n}\n\n.customTab\n  :global(.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child) {\n  border-color: transparent;\n}\n.customTab :global(.ant-radio-button-wrapper:not(:first-child)::before) {\n  background-color: transparent !important;\n}\n\n.customTab\n  :global(.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before) {\n  background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `H_2asCYDgjX0yQyvcrrn`,
	"feesAndCharges": `h5NdxtRf8VesrE6MmkMx`,
	"feesAndChargesHeader": `ah51s5u1EyFDzpNv3pQz`,
	"paymentBrakeDownHeader": `AiwwJ5ySvOiCRBHSrMPL`,
	"feesAndChargesBrakeDown": `q7PbkVtGahoG9vQPy2q7`,
	"feesAndChargesBrakeDownItem": `Xc4Xg7JQ2ACIV77EGvbh`,
	"paymentBrakeDown": `mJcSu6uJLwkGSO4OEo9D`,
	"paymentBrakeDownItem": `Ofr1dsuaun5zLzHVw_77`,
	"paymentBrakeDownItemNetPayable": `VM38hh7JwfBCUCSwR1ON`,
	"paymentDetailsWrapper": `umG_p2b5aHFXlJCJQqds`,
	"paymentDetailsHeader": `ylTbdB8fYhrTAMggf2iW`,
	"paymentDetailsTicketCount": `eITQbNlsEYojlDdaXcVs`,
	"promotionSection": `sFC_xk4cb_IvN_vZJWj8`,
	"voucherSection": `wVNNPcbcv16djplMAD9z`,
	"pledgeDetailsSection": `DeErpIrBngOAs_Iw2ve8`,
	"pledgeDetailsItem": `cICky6NqvH9e9sEZmV64`,
	"promotionSectionHeader": `pSsbe4V9SfayBg3T85uL`,
	"promotionSectionTitle": `VdKlxH4pur3IdAqmSeuJ`,
	"promotionButton": `bLRNu7R1VmRHx4HQ3Ewm`,
	"promotionSectionBody": `E2CjZ67jRs4WWfx7iH4x`,
	"noPromotionApplied": `vpV9dOdjsbsgjOjI10oy`,
	"buttonWrapper": `wmJNs2xJ2Swxgkk7Sgef`,
	"proceedToPayButton": `fIFStyuncJANlXJfNIYQ`,
	"imageLogo": `WddngL0Ti9M86RiESetd`,
	"promotionListWrapper": `jt7cWfKtMBKmR2GYiX8W`,
	"promotionListItem": `VwzfJqxgv6aWUiSicBBe`,
	"promotionCode": `TNkJCmfwQkOpCEBPfpqj`,
	"promotionRemarks": `Qd9cpwLOzjAKFQi_ZNZJ`,
	"promotionBottomRow": `rDOqS1vitfScA_uoZ7eH`,
	"promotionValidity": `krU4IBMsiFmo0J0sGQfA`,
	"promotionApplyButton": `Aoxzc42evR50MffDERBZ`,
	"promotionRemoveButton": `UPWdfwqw4eIULNM53clr`,
	"customTag": `YxjTtWcsRUtblfoq8Q82`,
	"wrapperDetails": `lHFO0QU2yHxoiN7fP7II`,
	"icon": `CQZZSZU1XtmvDF9IcmHS`,
	"sectionTitle": `XtsxM3m1GbpIQbcjlLk2`,
	"customTab": `Qx4QdK1DMcyrt0jeAlzy`
};
export default ___CSS_LOADER_EXPORT___;
